export default {
  SET_CURRENCY_DATA(state, data) {
    state.currencies = data;
  },
  SET_EXCHANGE_RATES(state, data) {
    state.exchange_rates = data;
  },
};
